import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import YoutubeEmbed from "../../components/youtubeEmbed/YoutubeEmbed";
import Page from "../page/Page";
import styles from "./about.module.css";

export default function About() {
  return (
    <Page>
      <div className={styles.about}>
        <h1>
          <FaInfoCircle /> About the project
        </h1>
        <p>
          Myths and Legends bring an extra dimension to a location. Once you
          know the story of a place, being there bubbles up new feelings and
          sensations - overlaying mental images and sounds from the story.
        </p>
        <p>
          There's a particular power to Mythical stories tied to locations.
          They're lovely to learn, but even better to invent!
        </p>

        <h2>Using the Myth Mapper</h2>
        <p>
          Hopefully all should be fairly straightforward. You can see what the
          various myths are by clicking on the icons on the map or in the menu
          at the side.{" "}
        </p>
        <YoutubeEmbed embedId={"56KTiNXVYbg"} />

        <h2>Inventing a new Local Myth</h2>
        <p>
          Wander around your local area and let your imagination run riot. Look
          for things that look interesting, odd, or tingle your senses.
        </p>
        <ul>
          <li>
            Have you ever looked at an oddly named road sign and wondered how it
            got it's name?
          </li>
          <li>
            Is there a narrow alley that gives you the creeps. Did something
            once lurk here?
          </li>
          <li>
            Is there a big gap somewhere, a missing house maybe? What might have
            happened?
          </li>
          <li>
            Ideas can come from anything big or small. Anything from a haunted
            bollard to a hidden underground city!
          </li>
        </ul>
        <p>
          Once an idea grabs you, write out the story of what happened. To add
          your myth to the site you need:
        </p>
        <ul>
          <li>A name and intro</li>
          <li>An audio recording of you reading out your story.</li>
          <li>
            A 4 cell comic drawn on an A4 sheet. Split the sheet into 4
            rectangles by folding in half in both directions and unfolding.
          </li>
          <li>A photo of the location where your story took place.</li>
        </ul>

        <h2>Adding and Editing Myths</h2>
        <p>
          If you're working with us to add Myths we should have already given
          you log in details. With them you'll be able to log in to Add, Edit
          and Delete myths.
        </p>
        <p>
          <a href="https://artfly.io/chris-dennett/">Contact me</a> if you're
          having any problems.
        </p>

        <YoutubeEmbed embedId={"siBZaPPGVHs"} />
        <h3>The Title, Description</h3>
        <p>
          The <strong>title</strong> of a Myth often includes the name of the
          location e.g. The Lock Ness Monster.
        </p>
        <p>
          The <strong>description</strong> should be a brief paragraph to
          introduce your Myth in a way that makes the reader want to learn more.
        </p>

        <h3>Map Pointer</h3>
        <p>Move the Map Pointer to location of your Myth on the map.</p>
        <p>
          You can do this by dragging the pointer or just clicking on the
          location you want.
        </p>
        <p>
          Use the zoom controls to get the position exactly where you want it.
        </p>

        <h3>Place Photo</h3>
        <p>
          This should be a photo of the location. This can be easier to do with
          a phone of tablet.
        </p>

        <h3>The Comic</h3>
        <p>
          Create a comic by folding a sheet of A4 in half in both directions.
          Use each of the 4 rectangles this creates as a frame for your comic.
        </p>
        <p>
          The first "cell" of the comic should be the top left. The second is
          the top right, followed by bottom left and then bottom right.
        </p>
        <p>
          Once you've saved a photo of the comic, you'll need to crop the image
          to fit it exactly to the edges of the page.
        </p>
        <p>
          To do this press the Edit Crop button. Then drag the colourful corner
          circle to the corners. Watch the video above to see this in action.
        </p>

        <h3>The Audio</h3>
        <p>
          You'll need to use your own recording equipment to record yourself
          telling the story of your Myth.
        </p>
        <p>
          The easiest way to do this is to use a phone app. You may find your
          phone already has an app to do this e.g. Voice Memos app on iPhone or
          Voice Recorder on Android phones.
        </p>
        <p>
          If you don't already have a voice recording app there are plenty of
          free options in the app store.
        </p>
      </div>
    </Page>
  );
}
